import { hasFlag } from 'country-flag-icons';

const COUNTRY_CODE_ALIASES = {
  USA: 'US',
  UK: 'GB',
  GBR: 'GB',
};

export const normalizeCountryCodeOfOrigin = (value) => {
  if (value === null || value === undefined) return '';
  const trimmed = String(value).trim().toUpperCase();
  if (!trimmed) return '';
  return COUNTRY_CODE_ALIASES[trimmed] || trimmed;
};

export const validateCountryCodeOfOrigin = (value, { invalidMessage } = {}) => {
  const normalized = normalizeCountryCodeOfOrigin(value);
  if (!normalized) return { value: '', error: null };
  if (!/^[A-Z]{2}$/.test(normalized) || !hasFlag(normalized)) {
    return { value: normalized, error: invalidMessage || 'Invalid country code' };
  }
  return { value: normalized, error: null };
};

export const normalizeHarmonizedSystemCode = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/\s+/g, '').replace(/\D/g, '');
};

export const validateHarmonizedSystemCode = (value, { invalidMessage } = {}) => {
  const normalized = normalizeHarmonizedSystemCode(value);
  if (!normalized) return { value: '', error: null };
  if (!/^\d{6,13}$/.test(normalized)) {
    return { value: normalized, error: invalidMessage || 'Invalid HS code' };
  }
  return { value: normalized, error: null };
};
